import React from 'react';
import styled from '@emotion/styled';
import { WarningBannerBase } from './WarningBannerBase';

const Anchor = styled.a`
  text-decoration: underline;
  font-weight: 600;
  color: #583900;
`;

/* TODO: update link when docs are ready  */
export const TargetingWarning = () => (
  <WarningBannerBase>
    Targeting rules will prevent the experience from showing at this URL.{' '}
    <Anchor href="https://www.commandbar.com/docs/other/share-links" target="_blank" rel="noreferrer">
      Learn more ↗
    </Anchor>
  </WarningBannerBase>
);
